export class Environment {
    isMixPanelActivated!: boolean;
    isEnergyManager!: boolean;
    mixPanelToken!: string;

    advizeoClientId!: string;
    advizeoClientSecret!: string;

    globalInfoMessageUrl!: string;
    currentMode!: AdvizeoEnvironment;

    coreApiEndPoint!: string;
    backendRoot!: string;
}

export enum AdvizeoEnvironment {
    DEV = 'dev',
    PREPROD = 'preprod',
    EM = 'em',
    PROD = 'prod',
    LOCAL = 'local'
}
